import React from 'react';
import classNames from 'classnames';

import LoadingSpinner from './LoadingSpinner';
import styles from './LoadingOverlay.module.scss';

interface LoadingOverlayProps {
  className?: string | null;
}

const LoadingOverlay = ({ className = null }: LoadingOverlayProps) => (
  <div
    className={classNames(
      'fixed-top d-flex flex-column w-100 h-100',
      styles.overlay,
      className,
    )}
    data-testid="loading-overlay"
  >
    <LoadingSpinner />
  </div>
);

export default LoadingOverlay;
